import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Tabdesign from "./Tabdesign";
import { baseURL } from "../../constants/Api";
import axios from "axios";
import BackButton from "../bars/BackButton";
import { HouseKeepingPageView } from "../../utils/Analytics";

function HouseKeeping() {
    const navigate = useNavigate();
    const location = useLocation();

    const currentUrl = window.location.href;
    const urlArray = currentUrl.split("/");
    const hotelId = urlArray[urlArray.length - 1];
    const bookingId = localStorage.getItem("guestBookingId");
    localStorage.setItem("hotel-id", hotelId);
    let [isOpen, setIsOpen] = useState(false);
    const [guestId, SetGuestId] = useState("");
    const [reservationId, SetReservationId] = useState("");
    const [roomId, SetroomId] = useState("");
    const [multipleRoom, SetMultipleRoom] = useState(false);
    const [checkedIn, SetCheckedIn] = useState(false);
    const [historyShow, SetHistoryShow] = useState(false);

    // console.log(hotelId)

    useEffect(() => {
        window.scrollTo(0, 0);
        HouseKeepingPageView();
    }, []);

     
  //dummy date
  let start_time = "00:00";
  let close_time = "00:00"
    

    return (
        <div className="min-h-[740px] h-full">


            <div className=" ">

                <div className="section-wrap pt-[30px] lg:px-12 md:px-8 sm:px-6 px-4 font-medium w-full h-full">
                    <div className="text-base lg:text-[28px] font-semibold text-left relative">
                        <div className="flex space-x-2 items-center">
                            <BackButton />
                            <div>House Keeping services</div>
                        </div>
                    </div>
                    <Tabdesign
                        guestId={guestId}
                        reservationId={reservationId}
                        roomId={roomId}
                        multipleRoom={multipleRoom}
                        checkedIn={checkedIn}
                    />
                </div>
            </div>

            {/* <div className="section-wrap lg:hidden block lg:pt-[30px] pt-[180px] lg:px-12 md:px-8 sm:px-6 px-4 font-medium w-full h-full">
            <div className="text-base lg:text-[28px] font-semibold text-left relative">
                        <div className="flex space-x-2 items-center">
                            <BackButton />
                            <div>House Keeping services</div>
                        </div>
                        <div className="text-xs text-[#BABABA] pt-3">Opening hours - 07.00 am -10.00pm</div>
                    </div>
                <Tabdesign
                    guestId={guestId}
                    reservationId={reservationId}
                    roomId={roomId}
                    multipleRoom={multipleRoom}
                    checkedIn={checkedIn}
                />

            </div> */}

           
        </div>
    );
}

export default HouseKeeping;
